
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import MyFooter from '../../components/common/myFooter'
import { getArticleInfo } from '../../api/public'

export default {
name: 'ArticleContent',
components: {
XHeader,
Flexbox,
FlexboxItem,
Cell,
CellBox,
MyFooter
},
data () {
return {
title: '精彩潮州',
id: null,
sign: null,
article: null,
bottomTitle: this.MyGlobal.title
}
},
mounted () {
this.id = this.$route.params.id
this.sign = this.$route.params.sign
this.getArticleContent()
},
methods: {
goBack () {




this.$router.go(-1)






},
getArticleContent () {
getArticleInfo(this.id, this.sign).then(res => {
this.article = res.data
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/article/content.vue